import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_wall_organizers: FaireCategoryEntity = {
  token: "cat_wall-organizers",
  type: "category",
  name: "Wall organizers",
  level: 3,
  parentToken: "cat_home-decor-wall",
  href: "/category/home-decor/wall-decor/wall-organizers",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
